import { IconProps } from "../../models/Icon";


export function PaperIcon({ size = 20, color = "#000", opacity="1"}: IconProps) {
    return(
        <svg 
            width={size} 
            height={size} 
            viewBox="0 0 15 15" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M9.74032 0.395044L13.1028 3.75754C13.1966 3.85129 13.2497 3.97942 13.2497 4.11223V13.7482C13.2497 14.0247 13.0263 14.2482 12.7497 14.2482H2.74969C2.47313 14.2482 2.24969 14.0247 2.24969 13.7482V0.748169C2.24969 0.471606 2.47313 0.248169 2.74969 0.248169H9.3872C9.52001 0.248169 9.64657 0.301294 9.74032 0.395044ZM9.15595 4.34192H12.0966L9.15595 1.40129V4.34192ZM3.37469 13.1232H12.1247V5.40442H8.7497C8.57565 5.40442 8.40873 5.33528 8.28566 5.21221C8.16259 5.08914 8.09345 4.92222 8.09345 4.74817V1.37317H3.37469V13.1232ZM4.86108 6.85923H10.6389C10.7618 6.85923 10.8611 6.95854 10.8611 7.08146V11.5259C10.8611 11.6488 10.7618 11.7481 10.6389 11.7481H4.86108C4.73816 11.7481 4.63885 11.6488 4.63885 11.5259V7.08146C4.63885 6.95854 4.73816 6.85923 4.86108 6.85923ZM8.88886 8.30368H10.3611V7.35923H8.88886V8.30368ZM8.88886 9.85923H10.3611V8.74812H8.88886V9.85923ZM8.44441 8.74812H7.05552V9.85923H8.44441V8.74812ZM7.05552 8.30368H8.44441V7.35923H7.05552V8.30368ZM6.61108 8.74812H5.13885V9.85923H6.61108V8.74812ZM6.61108 7.35923H5.13885V8.30368H6.61108V7.35923ZM6.61108 10.3037H5.13885V11.2481H6.61108V10.3037ZM8.44441 10.3037H7.05552V11.2481H8.44441V10.3037ZM8.88886 11.2481H10.3611V10.3037H8.88886V11.2481Z" 
                fill={color} 
                opacity={opacity}
            />
        </svg>
    )
}
